import type React from "react";
import {
  DateRangePicker as ReactDatesDateRangePicker,
  DayPickerRangeController as ReactDatesDayPickerRangeController,
  DayPickerSingleDateController as ReactDatesDayPickerSingleDateController,
  SingleDatePicker as ReactDatesSingleDatePicker,
  type DayPickerRangeControllerShape,
  type DayPickerSingleDateControllerShape,
  type DateRangePickerShape,
  type SingleDatePickerShape,
} from "react-dates";

type CompatComponent<P> = (props: P) => React.ReactElement | null;

// react-dates ships legacy component typings that clash with React 18 JSX checks.
export const DateRangePicker =
  ReactDatesDateRangePicker as unknown as CompatComponent<DateRangePickerShape>;

export const SingleDatePicker =
  ReactDatesSingleDatePicker as unknown as CompatComponent<SingleDatePickerShape>;

export const DayPickerRangeController =
  ReactDatesDayPickerRangeController as unknown as CompatComponent<DayPickerRangeControllerShape>;

export const DayPickerSingleDateController =
  ReactDatesDayPickerSingleDateController as unknown as CompatComponent<DayPickerSingleDateControllerShape>;
